export default [
    {
      title: 'Lottery',
      customIcon: 'LotterySVG',
      children: [
        {
          title: 'Activity details',
          route: 'custom-module',
          path: '/custom-module/lottery',
        },
      ],
    },
  ];
  